const example = $('[type=template]');
const xlyx = $('[type=xlyx]');
const xlyx_tem = $('.xlyx_template');
const reqUrl = $('#recommendUrl').val() || '//a.9game.cn/recommend/queryv2/';
const gameList = '[type=xlyx-count-item]';
const list_item_num = 4; // 每行游戏数量
const forMainReg = /@for=\d+@[\s\S]+?@endfor@/;
// 下了又下会优先寻找'[type=xlyx-count-item]'上的gameId gameName做推荐。 兜底寻找.game-recommend-download上的gameId gameName。
class Module{
  constructor(){
    this._callback = function(){};
    this.init();
  }

  set callback(func){
    this._callback = func;
  }

  init(){
    const that = this;
    // 下了又下模版隐藏
    xlyx_tem.hide();
    // 猜你喜欢
    example.each(function() {
      const template = $(this);
      const params = template.data('params') || {};
      params.scenarioId = $(this).data('scenarioId');
      params.isFinishRealName = true;
      ajaxInfo({
        data: params,
        callback(result) {
          if (result.data) {
            const size = result.data.items && result.data.items.length;
            const hideMore = false;
            if (size < 2) {
              template.hide();
            } else {
              const datas = [];
              for (let i = 0;i < result.data.items.length;i ++) {
                let temp = result.data.items[i];
                for (let j in temp) {
                  if (Object.prototype.toString.call(temp[j]).toLocaleLowerCase() == '[object string]') {
                    temp[j] = temp[j].replace('http://', 'https://');
                  }
                }
                if (temp.downloadStatus == 1) {
                  temp.downUrl = temp.zoneUrl;
                }
                datas.push(temp);
              }
              let html = template.html();
              const totalReg = /@total@/;
              html = html.replace(totalReg, size);
              // const _html = templateToHtml(result.data.items, html);
              const _html = templateToHtml(datas, html);
              html = html.replace(forMainReg, _html);
              template.html(html).show();
              size < 5 ? template.find('.more1').hide() : '';
              if (html && window.GLOBAL_AgStat) {
                window.GLOBAL_AgStat.addRecommendExplorePortalEleMap(template);
                window.GLOBAL_AgStat.addRecommendClick(template);
              }
            }
          }
        },
      });
    });
    // 下了又下
    $(document).on('click', '.game-recommend-download', function() {
      let _html;
      let data;
      const _this = $(this);
      const item = $(this).closest(gameList);
      const itemId = item.data('gameId') || _this.data('gameId');
      const game_name = item.data('gameName') || _this.data('gameName');
      const idx = Math.ceil(item.data('idx') / list_item_num);

      let xlyx_template = item.next('.xlyx_template');
      const position = item.siblings('[type=xlyx]').eq(idx - 1);
      const swiper_xlyx = item.closest('.swiper-wrapper');
      const swiper_xlyx_position = swiper_xlyx.length
        ? swiper_xlyx.siblings('[type=xlyx]')
        : false;

      xlyx_template.length === 0 ? (xlyx_template = $('.xlyx_template')) : '';
      _html = item.siblings('.xlyx_template').html()
        ? item.siblings('.xlyx_template').html()
        : xlyx_template.html();

      // step1: 下了又下添加gamename 和 触发下了又下的游戏id
      const gameNameReg = /@gamename@/;
      const formDownIdReg = /@fromDownId@/;
      _html = _html.replace(gameNameReg, game_name);
      _html = _html.replace(formDownIdReg, item.data('gameId'));

      data = {
        scenarioId: xlyx_template.data('scenarioId'),
        itemId,
        isFinishRealName: true, // 表示已经做了实名制处理才会有数据返回
      };

      ajaxInfo({
        data,
        callback(result) {
          const items = result.data.items;
          if (items.length > 0) {
            const datas = [];
            for (let i = 0;i < items.length;i ++) {
              let temp = items[i];
              for (let j in temp) {
                if (Object.prototype.toString.call(temp[j]).toLocaleLowerCase() == '[object string]') {
                  temp[j] = temp[j].replace('http://', 'https://');
                }
              }
              if (temp.downloadStatus == 1) {
                temp.downUrl = temp.zoneUrl;
              }
              datas.push(temp);
            }
            const html = templateToHtml(datas, _html);
            _html = _html.replace(forMainReg, html);

            if (position.length) {
              xlyx.empty().hide();
              position.html(_html).show();
            } else if (swiper_xlyx.length) {
              xlyx.empty().hide();
              swiper_xlyx_position.html(_html).show();
            } else {
              _this
                .closest(gameList)
                .siblings('.game-recommend')
                .each(function() {
                  if ($(this).css('display') !== 'none') {
                    $(this).remove();
                  }
                });
              _this.closest(gameList).after(_html);
            }

            // 打曝光点
            if (window.countFunc) {
              countFunc.count_show();
            }
          }
        },
      });
    });

    function templateToHtml(info, template, item) {
      const replaceReg = /@(\w+)@/g;
      const forReg = /@for=(\d+)@([\S\s]*?)@endfor@/;
      let str = '';

      const match = template.match(forReg);
      if(!match) return;
      const size = match[1];
      const forList = match[2];

      info.forEach(function(item, i) {
        item.idx = i + 1;
        if (!item.src) {
          item.src = 'src';
        }
      });

      info.slice(0, size).map(function(item, i) {
        var temp = forList.replace(replaceReg, function (match, $1) {
          return item[$1];
        });
        // 游戏不能下载
        if (item.downloadStatus == 1) {
          temp = temp.replace('下载','详情');
        }
        str += temp;
      });
      str = str.replace(/data-tep-href=/g,'href=');
      return str;
    }

    function ajaxInfo(arg) {
      if (arg.data) {
        arg.data.identify = $('#realNameIdentify').data('identify');
      }
      $.ajax({
        type: arg.type || 'POST',
        url: reqUrl,
        data: arg.data,
        timeout: 4000,
        success(result) {
          arg.callback(result);
          that._callback();
        },
        error(err) {
          console.log('request error!');
        },
      });
    }
  }
}

module.exports = new Module();



// WEBPACK FOOTER //
// ./lib/js/public/recommend.js